var _assertThisInitialized = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _get = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function () {
  var e = {
      655: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = r(609),
          i = r.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", ""]);
        var n = i;
      },
      609: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var r = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(r, "}") : r;
            }).join("");
          }, t.i = function (e, r, o) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var i = {};
            if (o) for (var n = 0; n < this.length; n++) {
              var c = this[n][0];
              null != c && (i[c] = !0);
            }
            for (var a = 0; a < e.length; a++) {
              var s = [].concat(e[a]);
              o && i[s[0]] || (r && (s[2] ? s[2] = "".concat(r, " and ").concat(s[2]) : s[2] = r), t.push(s));
            }
          }, t;
        };
      },
      62: function _(e, t, r) {
        "use strict";

        var o,
          i = function i() {
            return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
          },
          n = function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var r = document.querySelector(t);
                if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                  r = r.contentDocument.head;
                } catch (e) {
                  r = null;
                }
                e[t] = r;
              }
              return e[t];
            };
          }(),
          c = [];
        function a(e) {
          for (var t = -1, r = 0; r < c.length; r++) if (c[r].identifier === e) {
            t = r;
            break;
          }
          return t;
        }
        function s(e, t) {
          for (var r = {}, o = [], i = 0; i < e.length; i++) {
            var n = e[i],
              s = t.base ? n[0] + t.base : n[0],
              l = r[s] || 0,
              d = "".concat(s, " ").concat(l);
            r[s] = l + 1;
            var u = a(d),
              b = {
                css: n[1],
                media: n[2],
                sourceMap: n[3]
              };
            -1 !== u ? (c[u].references++, c[u].updater(b)) : c.push({
              identifier: d,
              updater: k(b, t),
              references: 1
            }), o.push(d);
          }
          return o;
        }
        function l(e) {
          var t = document.createElement("style"),
            o = e.attributes || {};
          if (void 0 === o.nonce) {
            var i = r.nc;
            i && (o.nonce = i);
          }
          if (Object.keys(o).forEach(function (e) {
            t.setAttribute(e, o[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var c = n(e.insert || "head");
            if (!c) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            c.appendChild(t);
          }
          return t;
        }
        var d,
          u = (d = [], function (e, t) {
            return d[e] = t, d.filter(Boolean).join("\n");
          });
        function b(e, t, r, o) {
          var i = r ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
          if (e.styleSheet) e.styleSheet.cssText = u(t, i);else {
            var n = document.createTextNode(i),
              c = e.childNodes;
            c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(n, c[t]) : e.appendChild(n);
          }
        }
        function f(e, t, r) {
          var o = r.css,
            i = r.media,
            n = r.sourceMap;
          if (i ? e.setAttribute("media", i) : e.removeAttribute("media"), n && "undefined" != typeof btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), " */")), e.styleSheet) e.styleSheet.cssText = o;else {
            for (; e.firstChild;) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(o));
          }
        }
        var p = null,
          h = 0;
        function k(e, t) {
          var r, o, i;
          if (t.singleton) {
            var n = h++;
            r = p || (p = l(t)), o = b.bind(null, r, n, !1), i = b.bind(null, r, n, !0);
          } else r = l(t), o = f.bind(null, r, t), i = function i() {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(r);
          };
          return o(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              o(e = t);
            } else i();
          };
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = i());
          var r = s(e = e || [], t);
          return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var o = 0; o < r.length; o++) {
                var i = a(r[o]);
                c[i].references--;
              }
              for (var n = s(e, t), l = 0; l < r.length; l++) {
                var d = a(r[l]);
                0 === c[d].references && (c[d].updater(), c.splice(d, 1));
              }
              r = n;
            }
          };
        };
      },
      704: function _(e, t, r) {
        e.exports = r(79)("./src/core.js");
      },
      492: function _(e, t, r) {
        e.exports = r(79)("./src/engine.js");
      },
      273: function _(e, t, r) {
        e.exports = r(79)("./src/ui.js");
      },
      209: function _(e, t, r) {
        e.exports = r(79)("./src/utils.js");
      },
      79: function _(e) {
        "use strict";

        e.exports = CKEditor5.dll;
      }
    },
    t = {};
  function r(o) {
    var i = t[o];
    if (void 0 !== i) return i.exports;
    var n = t[o] = {
      id: o,
      exports: {}
    };
    return e[o](n, n.exports, r), n.exports;
  }
  r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, {
      a: t
    }), t;
  }, r.d = function (e, t) {
    for (var o in t) r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
      enumerable: !0,
      get: t[o]
    });
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var o = {};
  (function () {
    "use strict";

    r.r(o), r.d(o, {
      ClassicEditor: function ClassicEditor() {
        return R;
      }
    });
    var e = r(704),
      t = r(209);
    var i = function i(e) {
      return null != e && "object" == typeof e;
    };
    var n = "object" == typeof global && global && global.Object === Object && global;
    var c = "object" == typeof self && self && self.Object === Object && self;
    var a = (n || c || Function("return this")()).Symbol;
    var s = Object.prototype,
      l = s.hasOwnProperty,
      d = s.toString,
      u = a ? a.toStringTag : void 0;
    var b = function b(e) {
      var t = l.call(e, u),
        r = e[u];
      try {
        e[u] = void 0;
        var o = !0;
      } catch (e) {}
      var i = d.call(e);
      return o && (t ? e[u] = r : delete e[u]), i;
    };
    var f = Object.prototype.toString;
    var p = function p(e) {
      return f.call(e);
    };
    var h = a ? a.toStringTag : void 0;
    var k = function k(e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : h && h in Object(e) ? b(e) : p(e);
    };
    var v = function (e, t) {
      return function (r) {
        return e(t(r));
      };
    }(Object.getPrototypeOf, Object);
    var m = Function.prototype,
      y = Object.prototype,
      g = m.toString,
      _ = y.hasOwnProperty,
      w = g.call(Object);
    var j = function j(e) {
      if (!i(e) || "[object Object]" != k(e)) return !1;
      var t = v(e);
      if (null === t) return !0;
      var r = _.call(t, "constructor") && t.constructor;
      return "function" == typeof r && r instanceof r && g.call(r) == w;
    };
    var T = function T(e) {
      return i(e) && 1 === e.nodeType && !j(e);
    };
    var x = r(273),
      O = r(492);
    var E = /*#__PURE__*/function (_e$EditorUI) {
      _inherits(E, _e$EditorUI);
      function E(e, r) {
        var _this;
        _classCallCheck(this, E);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(E).call(this, e)), _this.view = r, _this._toolbarConfig = (0, x.normalizeToolbarConfig)(e.config.get("toolbar")), _this._elementReplacer = new t.ElementReplacer();
        return _this;
      }
      _createClass(E, [{
        key: "init",
        value: function init(e) {
          var t = this.editor,
            r = this.view,
            o = t.editing.view,
            i = r.editable,
            n = o.document.getRoot();
          i.name = n.rootName, r.render();
          var c = i.element;
          this.setEditableElement(i.name, c), this.focusTracker.add(c), r.editable.bind("isFocused").to(this.focusTracker), o.attachDomRoot(c), e && this._elementReplacer.replace(e, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var e = this.view,
            t = this.editor.editing.view;
          this._elementReplacer.restore(), t.detachDomRoot(e.editable.name), e.destroy(), _superPropGet(E, "destroy", this, 3)([]);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var e = this.editor,
            t = this.view,
            r = e.editing.view;
          t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, t.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", function (_ref) {
            var e = _ref.top;
            return e;
          }), t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), (0, x.enableToolbarKeyboardFocus)({
            origin: r,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: e.keystrokes,
            toolbar: t.toolbar
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var e = this.editor,
            t = e.editing.view,
            r = t.document.getRoot(),
            o = e.sourceElement,
            i = e.config.get("placeholder") || o && "textarea" === o.tagName.toLowerCase() && o.getAttribute("placeholder");
          i && (0, O.enablePlaceholder)({
            view: t,
            element: r,
            text: i,
            isDirectHost: !1,
            keepOnFocus: !0
          });
        }
      }, {
        key: "element",
        get: function get() {
          return this.view.element;
        }
      }]);
      return E;
    }(e.EditorUI);
    var S = r(62),
      C = r.n(S),
      P = r(655),
      F = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    C()(P.Z, F);
    P.Z.locals;
    var M = /*#__PURE__*/function (_x$BoxedEditorUIView) {
      _inherits(M, _x$BoxedEditorUIView);
      function M(e, t) {
        var _this2;
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, M);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(M).call(this, e)), _this2.stickyPanel = new x.StickyPanelView(e), _this2.toolbar = new x.ToolbarView(e, {
          shouldGroupWhenFull: r.shouldToolbarGroupWhenFull
        }), _this2.editable = new x.InlineEditableUIView(e, t);
        return _this2;
      }
      _createClass(M, [{
        key: "render",
        value: function render() {
          _superPropGet(M, "render", this, 3)([]), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }]);
      return M;
    }(x.BoxedEditorUIView);
    var R = /*#__PURE__*/function (_e$Editor) {
      _inherits(R, _e$Editor);
      function R(r) {
        var _this3;
        var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, R);
        if (!T(r) && void 0 !== o.initialData) throw new t.CKEditorError("editor-create-initial-data", null);
        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(R).call(this, o)), void 0 === _this3.config.get("initialData") && _this3.config.set("initialData", function (e) {
          return T(e) ? (0, t.getDataFromElement)(e) : e;
        }(r)), T(r) && (_this3.sourceElement = r), _this3.model.document.createRoot();
        var i = !_this3.config.get("toolbar.shouldNotGroupWhenFull"),
          n = new M(_this3.locale, _this3.editing.view, {
            shouldToolbarGroupWhenFull: i
          });
        _this3.ui = new E(_assertThisInitialized(_assertThisInitialized(_this3)), n), (0, e.attachToForm)(_assertThisInitialized(_assertThisInitialized(_this3)));
        return _this3;
      }
      _createClass(R, [{
        key: "destroy",
        value: function destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _superPropGet(R, "destroy", this, 3)([]);
        }
      }], [{
        key: "create",
        value: function create(e) {
          var _this4 = this;
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (r) {
            var o = new _this4(e, t);
            r(o.initPlugins().then(function () {
              return o.ui.init(T(e) ? e : null);
            }).then(function () {
              return o.data.init(o.config.get("initialData"));
            }).then(function () {
              return o.fire("ready");
            }).then(function () {
              return o;
            }));
          });
        }
      }]);
      return R;
    }(e.Editor);
    (0, t.mix)(R, e.DataApiMixin), (0, t.mix)(R, e.ElementApiMixin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).editorClassic = o;
})();